import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FieldFilterPipe } from './field-filter.pipe';
import { MomentPipe } from './moment.pipe';
import {TrustedHtmlPipe} from "./trusted-html.pipe";

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [
    FieldFilterPipe,
    MomentPipe,
    TrustedHtmlPipe
  ],
  exports: [
    FieldFilterPipe,
    MomentPipe,
    TrustedHtmlPipe
  ]
})
export class PipesModule { }
